import React from "react";
import SEO, { localBusinessSchema } from "../components/SEO";
import Hero from "../components/Hero";
import Services from "../components/Services";
import BookingForm from "../components/BookingForm";
import WhyChooseUs from "../components/WhyChooseUs";
import Testimonials from "../components/Testimonials";
import ClientsCarousel from "../components/ClientsCarousel";

const homeSchema = [
  localBusinessSchema,
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Bar Spot Ltd",
    "url": "https://www.barspotltd.co.uk",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.barspotltd.co.uk/?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Mobile Bar Hire",
    "provider": { "@id": "https://www.barspotltd.co.uk/#business" },
    "areaServed": [
      { "@type": "City", "name": "Birmingham" },
      { "@type": "City", "name": "Cambridge" },
      { "@type": "AdministrativeArea", "name": "West Midlands" },
      { "@type": "AdministrativeArea", "name": "Worcestershire" },
      { "@type": "AdministrativeArea", "name": "Cambridgeshire" }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Mobile Bar Hire Packages",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Wedding Bar Hire" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Corporate Event Bar Hire" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Festival Bar Hire" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Private Party Bar Hire" } }
      ]
    }
  }
];

const HomePage = () => {
  return (
    <>
      <SEO
        title="Mobile Bar Hire Birmingham & UK | Bar Spot Ltd"
        description="Award-winning mobile bar hire serving Birmingham, Cambridge & across the UK. Wedding bars, corporate events & festivals. Get your free quote in 2 minutes."
        canonical="/"
        schema={homeSchema}
      />
      <Hero />
      <Services />
      <BookingForm />
      <WhyChooseUs />
      <ClientsCarousel />
      <Testimonials />
    </>
  );
};

export default HomePage;
